import { useQuery } from "@tanstack/react-query";

import { getCampaign } from "../../api/queries";

export const useCampaign = (id: string) => useQuery(["campaign", id], () => getCampaign(id));
